import { useEffect, useState } from "react";

/** Lecture ponctuelle d'une media query (faux hors navigateur). */
export function matchMediaSafe(query: string): boolean {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia(query).matches;
}

/**
 * Une media query, réactive. Initialisée de façon synchrone : le premier rendu
 * voit déjà la bonne valeur, sans bascule au montage.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => matchMediaSafe(query));

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
